import { Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
const noop = () => {
};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputComponent),
    multi: true
};

@Component({
    selector: 'app-input',
    templateUrl: 'input.component.html',
    styleUrls: ['./input.component.scss'],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class InputComponent implements OnInit, ControlValueAccessor {

    @ViewChild('input', { static: true }) input: ElementRef<HTMLInputElement> | undefined;
    @Input() modelKey: string = '';
    @Input() label: string = "";
    @Input() manualyError: boolean = false;
    @Input() type: string = "";
    @Input() isComboSearch: boolean = false;
    @Input() msgError: string = "";
    @Input() icon: string = "";
    @Input() readonly: boolean = false;
    @Input() typeText: string = 'all';
    @Input() required: boolean = false;
    @Input() help: string = "";
    @Input() maxLength: number = 500;
    @Input() placeholder: string = '';
    @Input() singleWord = false;
    @Input() white_background = false;
    @Input() disabled = false;
    @Input() addminSuffix = false;
    @Input() upLabel: boolean = false;
    @Input() percentagePromo = false;
    @Input() ErrorTitle = false;
    @Input() isNumberRequired: boolean = false;
    @Input() showCharCounter: boolean = false;
    @Input() recommendedLimit: number = 100;

    @Output() eventIcon = new EventEmitter<boolean>();;
    focus: boolean = false;
    @Input() isElasticSearch = false;
    // @Input() searchFunction: (args: any) => {};
    @Input() inputHeight: string = '57px';
    //The internal data model
    @Input() innerValue: any = "";
    //Placeholders for the callbacks which are later provided
    //by the Control Value Accessor
    @Output() valueChanged = new EventEmitter<any>();
    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    constructor() {
    }

    ngOnInit() {
    }

    validate(): boolean {
        if (!this.manualyError) {
            if (this.required) {
                if (this.value) {
                    this.msgError = ''
                } else {
                    this.msgError = 'Campo requerido'
                }
            } else {
                this.msgError = ''
            }
        } else {
            this.msgError = this.msgError;
        }


        if (!this.msgError && this.typeText != 'all') {
            if (this.typeText == 'permalink') {
                const valid = /^[a-z0-9-]+$/.test(this.value);
                if (!valid || !this.value.trim()) {
                    this.msgError = 'El permalink es obligatorio y solo puede tener minúsculas, números y guiones (-)';
                } else {
                    this.msgError = '';
                }
            }
            else if (this.typeText == 'text') {
                if (!this.singleWord) {
                    if (new RegExp(/^[a-zA-Z\sñÑáéíóúÁÉÍÓÚüÜ]+$/).test(this.value)) {
                        this.msgError = ''
                    } else {
                        this.msgError = 'Solo valores alfabéticos permitidos'
                    }
                } else {
                    if (this.value && this.label !== 'Mega Keyword') {

                        if (this.value.split(" ").length > 1) {
                            this.msgError = 'Solo se permite una palabra, no se permiten espacios, números ni caracteres.'
                        }
                        if (!(new RegExp(/^[a-zA-Z\sñÑáéíóúÁÉÍÓÚüÜ]+$/).test(this.value))) {
                            this.msgError = 'Solo se permite una palabra, no se permiten espacios, números ni caracteres.'
                        }
                    } else {
                        this.label === 'Mega Keyword' ? this.isCharacterEspecial(this.value) : null
                    }
                }
            } else {
                if (this.typeText == 'number') {
                    if (this.value !== null) {
                        if (new RegExp(/^\d+(\.\d+)*$/).test(this.value)) {
                            this.msgError = ''
                        } else {
                            this.msgError = 'Solo valores numéricos permitidos'
                        }
                    }
                }

                if (this.typeText == 'email') {
                    if (new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z]{2,4}$/).test(this.value)) {
                        this.msgError = ''
                    } else {
                        this.msgError = 'Solo formato de correo permitidos'
                    }
                }

                if (this.typeText == 'imgUrl') {
                    if (this.value.length > 255) {
                        this.msgError = 'Solo se permiten hasta 255 caracteres'
                    } else {
                        this.msgError = ''
                    }

                } else if (this.typeText === 'skuRef') {
                    const regex = /^[a-zA-Z0-9_-]{1,100}$/;
                    if (!this.value || !regex.test(this.value)) {
                        this.msgError = 'Formato inválido. Solo letras, números, guión y guión bajo (máx. 100 caracteres)';
                    } else {
                        this.msgError = '';
                    }
                }

            }
        }
        if (this.manualyError) {
            return true;
        } else {
            return this.msgError ? false : true
        }
    }

    full(): boolean {
        if (this.innerValue || this.innerValue === 0) {
            return true
        } else {
            return false
        }
    }


    //get accessor
    get value(): any {
        return this.innerValue;
    };

    //set accessor including call the onchange callback
    set value(v: any) {
        if (v !== this.innerValue) {
            this.innerValue = v;
            this.onChangeCallback(v);
        }
    }

    //Set touched on blur
    onBlur() {
        this.onTouchedCallback();
    }

    //From ControlValueAccessor interface
    writeValue(value: any) {
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
    }

    //From ControlValueAccessor interface
    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    //From ControlValueAccessor interface
    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }

    iconFuncion() {
        this.eventIcon.emit(true);
    }

    private isCharacterEspecial(cadena: string) {
        const expresionRegular = /[^a-zA-Z0-9\sáéíóúüÁÉÍÓÚÜ]/;
        const evaluated = expresionRegular.test(cadena);
        if (evaluated) {
            this.msgError = 'No se permiten caracteres especiales'
        }
    }


    onlyNumber($event) {
        if (this.isNumberRequired) {
            this.value = this.value.replace(/[^0-9]/g, '');
            const inputChar = String.fromCharCode($event.data);
            if (!/^\d$/.test(inputChar)) {
                $event.preventDefault(); // Evitar la entrada del carácter no numérico
            }
        }
    }



}
